import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Spinner from "../../Components/Spinner/Spinner";
import baseUrl from "../../baseUrl";

const SingleBlog = () => {
  const token = JSON.parse(localStorage.getItem("admin-token"));
  const { id } = useParams();
  const [blog, setBlog] = useState({});
  const [image, setImage] = useState("");

  useEffect(() => {
    axios
      .get(`${baseUrl}/admin/single-blog/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setBlog(res.data.blog);
        setImage(res.data.image);
      });
  }, [id, token]);

  const isEmpty = Object.keys(blog).length === 0;
  return (
    <>
      {isEmpty && <Spinner />}
      <main className="relative container mx-auto bg-white px-4">
        <div className="relative -mx-4 top-0 pt-[17%] overflow-hidden">
          <img
            className="absolute inset-0 object-cover object-top w-full h-full filter blur"
            src={image}
            alt=""
          />
        </div>
        <div className="mt-[-10%] w-1/2 mx-auto">
          <div className="relative pt-[56.25%] overflow-hidden rounded-2xl">
            <img
              className="w-full h-full absolute inset-0 object-cover"
              src={image}
              alt="blog pic"
            />
          </div>
        </div>
        <article className="max-w-prose mx-auto py-8">
          <h1 className="text-2xl font-bold"> {blog.title} </h1>
          <h2 className="mt-2 text-sm text-gray-500">
            Admin, {moment(blog.createdAt).fromNow()}
          </h2>
          <h2 className="mt-2 text-sm text-gray-500">
            {/* commentDetails.length comments */}
          </h2>
          <p className="mt-6"> {blog.description} </p>
        </article>
      </main>
    </>
  );
};

export default SingleBlog;
